import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
const mockCustomers = [{
  id: 1,
  name: 'Michael R.',
  location: 'Austin, TX',
  time: '2 minutes ago',
  color: 'bg-blue-500'
}, {
  id: 2,
  name: 'Sarah J.',
  location: 'Phoenix, AZ',
  time: '5 minutes ago',
  color: 'bg-purple-500'
}, {
  id: 3,
  name: 'David L.',
  location: 'Tampa, FL',
  time: '12 minutes ago',
  color: 'bg-emerald-500'
}, {
  id: 4,
  name: 'Jennifer M.',
  location: 'Denver, CO',
  time: '18 minutes ago',
  color: 'bg-orange-500'
}, {
  id: 5,
  name: 'Robert K.',
  location: 'Atlanta, GA',
  time: '24 minutes ago',
  color: 'bg-indigo-500'
}, {
  id: 6,
  name: 'Amanda T.',
  location: 'Charlotte, NC',
  time: '31 minutes ago',
  color: 'bg-rose-500'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      type: 'spring',
      stiffness: 300,
      damping: 24
    }
  }
};
export function RecentCustomers() {
  return <section className="w-full py-10 bg-gray-100" data-id="element-44">
      <div className="max-w-6xl mx-auto px-4" data-id="element-45">
        <div className="text-center mb-6" data-id="element-46">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900" data-id="element-47">
            Recently Approved Homeowners
          </h2>
          <p className="text-gray-500 mt-2" data-id="element-48">
            Join thousands of US residents upgrading their homes this year.
          </p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-49">
          {mockCustomers.map(customer => <motion.div key={customer.id} variants={itemVariants} className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 flex items-start gap-4 hover:shadow-md transition-shadow" data-id="element-50">
              <div className={`w-12 h-12 rounded-full flex items-center justify-center text-white font-bold text-lg shrink-0 ${customer.color}`} data-id="element-51">
                {customer.name.charAt(0)}
              </div>
              <div className="flex-1 min-w-0" data-id="element-52">
                <div className="flex items-center justify-between gap-2 mb-1" data-id="element-53">
                  <h3 className="font-bold text-gray-900 truncate" data-id="element-54">
                    {customer.name}
                  </h3>
                  <span className="text-xs text-gray-400 whitespace-nowrap" data-id="element-55">
                    {customer.time}
                  </span>
                </div>
                <p className="text-sm text-gray-600 truncate mb-2" data-id="element-56">
                  {customer.location}
                </p>
                <div className="flex items-center gap-1.5 text-xs font-medium text-green-600 bg-green-50 w-fit px-2 py-1 rounded-md" data-id="element-57">
                  <CheckCircle className="w-3.5 h-3.5" data-id="element-58" />
                  Approved for 2026 Remodel
                </div>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}